import { makeStyles } from '@material-ui/core/styles';
import { hSpacing } from 'src/common/helpers/config';
import { rem, vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  tab: {
    border: `1px solid ${themeColor.lightgray}`,
    padding: 4,
    '&:hover': {
      background: themeColor.white,
      boxShadow: 'none !important',
    },
  },
  tabSmallForm: {
    border: `1px solid ${themeColor.lightgray}`,
    padding: 4,
    width: vw(14.6484375),
    '&:hover': {
      background: themeColor.white,
      boxShadow: 'none !important',
    },
  },
  pluMenuText: {
    color: themeColor.defaultTextColor,
    fontWeight: 500,
    fontSize: vh(1.412),
    flex: '1 0 auto',
  },
  pluMenuTextSmallForm: {
    color: themeColor.defaultTextColor,
    fontWeight: 500,
    fontSize: rem(0.75),
    flex: '1 0 auto',
  },
  pluMenuPicture: {
    width: '2.976vw',
    paddingTop: '75%',
    borderRadius: 2,
    backgroundSize: '100% 100%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    boxSizing: 'border-box',
  },
  pluMenuTabContainer: {
    marginRight: hSpacing,
  },
}));
